/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import UpdateIcon from '@material-ui/icons/Create';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import PropTypes from 'prop-types';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import AddIcon from '@material-ui/icons/Add';
import MuiListItem from '@material-ui/core/ListItem';
import { Menu, TableContainer } from '@material-ui/core';
import MapIcon from '@material-ui/icons/Map';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuIcon from '@material-ui/icons/Menu';
import { Circle, GoogleMap, Polygon, Marker } from '@react-google-maps/api';
import MenuItem from '@material-ui/core/MenuItem';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import {
  handleCreateCity,
  handleChangePage,
  handleChangeRowsPerPage,
  handleChangeExpend,
  handleUpdateCities,
  removeZone,
  initDataConfig,
  handleUpdateDeliveryZone,
  handleCloseMenu,
  handleDisplayMenu,
  onEditCircle,
  onChangeLayout,
  onLoadPolygon,
  onLoadCircle,
  onEditPolygon,
  onCircleClick,
  onPolygonClick
} from './DeliveryZone.services';
import { styles } from './DeliveryZone.styles';
import {
  mainColor,
  UNIT,
  SUBLOCALITY_LEVEL_1,
  FIRST_LEVEL,
  SECOND_LEVEL,
  settings,
  ZONE_OPTIONS,
  DEFAULT_RADIUS
} from '../../constants';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import Paper from '../Paper';
import BackButton from '../BackButton';
import IconButton from '../IconButton';
import * as actions from '../../actions/index';
import { checkAccess } from '../../utils/admins';
import { displayPriceFormat, isObjectNotEmpty } from '../../utils/tools';
import { isDeliveryPriceInKm } from '../../utils/delivery';

import DeliveryZoneModal from '../DeliveryZoneModal';

const ListItem = withStyles({
  root: {
    padding: '0px 0px 5px 0px'
  },
  button: {
    '&:hover': {
      backgroundColor: `rgba(${mainColor.rgb}, 0.6)`
    },
    width: 'auto',
    borderRadius: '6px',
    paddingTop: '8px',
    paddingBottom: '8px'
  }
})(MuiListItem);
const ExpansionPanelSummary = withStyles({
  root: {
    borderBottom: '0.5px solid rgba(0,0,0,0.1) !important',
    backgroundColor: 'rgba(0,0,0,0)',
    height: '100%',
    width: '100%',
    '&$expanded': {
      height: '100%'
    },
    minHeight: '66px !important'
  },
  content: {
    '&$expanded': {},
    width: '100%',
    '& > :last-child': {
      paddingRight: 0
    }
  },
  expanded: {
    margin: '0px !important'
  }
})(props => <MuiExpansionPanelSummary {...props} />);

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

const ExpansionPanelDetails = withStyles(() => ({
  root: {
    borderBottom: '0.5px solid rgba(0,0,0,0.1)',
    borderRadius: UNIT,
    padding: 0
  }
}))(MuiExpansionPanelDetails);

const ExpansionPanel = withStyles(() => ({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    }
  },
  expanded: {
    '&$expanded': {
      margin: 0
    }
  }
}))(MuiExpansionPanel);

const INITIAL_STATE = {
  page: 0,
  rowsPerPage: 6,
  currentCities: [],
  addCityModal: false,
  updateCityModal: false,
  expanded: {},
  index: 0,
  selectedZone: {
    data: {}
  },
  isMap: true,
  deliveryZone: {},
  circleInfoWindows: {},
  polygonInfoWindows: {}
};
class DeliveryZone extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
    this.circleRefs = {};
    this.polygonRefs = {};
  }

  componentDidMount() {
    initDataConfig(this.props, this);
  }

  componentWillReceiveProps(nextProps) {
    const { configurations, shopId } = nextProps;
    const { configurations: oldConfig, shopId: oldShopId } = this.props;
    const { openCities, deliveryZones = [], address = {} } = configurations;
    const { openCities: oldOpenCities, deliveryZones: oldDeliveryZones = [] } = oldConfig;
    const { location = {} } = address;
    if (
      !_.isEqual(openCities, oldOpenCities) ||
      !_.isEqual(deliveryZones, oldDeliveryZones) ||
      !_.isEqual(shopId, oldShopId)
    ) {
      if (!_.isEqual(shopId, oldShopId))
        this.setState({
          selectedZone: {},
          center: {
            lng: location.longitude,
            lat: location.latitude
          }
        });
      initDataConfig(nextProps, this);
    }
  }

  renderMenu = zone => {
    const { anchorEl = null } = this.state;
    return (
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleCloseMenu(this)}
      >
        {_.map(['Modifier la zone', 'Supprimer la zone'], (type, index) => {
          return (
            <MenuItem
              onClick={() =>
                index === 0 ? handleUpdateDeliveryZone(zone, this) : removeZone(zone, this)
              }
            >
              {type}
            </MenuItem>
          );
        })}
      </Menu>
    );
  };

  renderDataZone = (e, i, isCity, city, typeZone) => {
    const { classes } = this.props;
    const { isMap, anchorEl, index } = this.state;
    const { deliveryFees = {}, name, color, priority, userServicePrice } = e;
    const fees = isMap ? deliveryFees : userServicePrice;
    return (
      <div key={i} className={classes.dataZone}>
        <p
          className={isMap ? classes.zone : classes.city}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexBasis: isMap && (!isDeliveryPriceInKm() ? '20%' : '45%')
          }}
        >
          {isMap ? (
            <div className={classes.zonePosition} style={{ backgroundColor: color }}>
              {priority}
            </div>
          ) : (
            name
          )}
        </p>
        <p className={isMap ? classes.zone : classes.city}>{displayPriceFormat(e.minimum)}</p>
        {!isDeliveryPriceInKm() && (
          <div className={isMap ? classes.zone : classes.city}>
            {fees &&
              _.keys(fees)
                .sort((a, b) => fees[a].priceOrder - fees[b].priceOrder)
                .map((f, j) => (
                  <ListItem className={classes.listItemStyle} key={j.toString()}>
                    <p className='text-center'>
                      {`> à ${displayPriceFormat(fees[f].priceOrder)} :`}
                      {'  '}
                      {displayPriceFormat(fees[f].fees)}
                    </p>
                  </ListItem>
                ))}
          </div>
        )}
        <div className={classes.lastCell}>
          {!isMap ? (
            <>
              {isCity && (
                <IconButton
                  title='Ajouter une spécification à un quartier'
                  label='Add'
                  className={classes.icon}
                  onClick={event => {
                    event.preventDefault();
                    event.stopPropagation();

                    handleCreateCity(SECOND_LEVEL, e.name, this);
                  }}
                  disabled={!checkAccess('features', 'deliveryZone')}
                >
                  <AddIcon />
                </IconButton>
              )}
              <IconButton
                title={`Modifier les paramètres ${isCity ? 'de la ville' : 'du quartier'} `}
                label='Update'
                className={classes.icon}
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleUpdateCities(e, isCity, city, typeZone, this);
                }}
                disabled={!checkAccess('features', 'deliveryZone')}
              >
                <UpdateIcon />
              </IconButton>
              <IconButton
                title={`Supprimer la zone ${e.name}`}
                label='Delete'
                className={classes.icon}
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  removeZone(e, this, city, isCity, typeZone);
                }}
                disabled={!checkAccess('features', 'deliveryZone')}
              >
                <DeleteOutlinedIcon />
              </IconButton>
            </>
          ) : (
            <>
              <IconButton
                label='More'
                className={classes.icon}
                onClick={e => handleDisplayMenu(e, i, this)}
              >
                <MoreVertIcon />
              </IconButton>

              {anchorEl && index === i && this.renderMenu(e)}
            </>
          )}
        </div>
      </div>
    );
  };

  rendersubZone = (dataZone, e, typeZone) => {
    const { classes } = this.props;
    const title = typeZone === SUBLOCALITY_LEVEL_1 ? 'Arrondissements:' : 'Quartiers:';
    return (
      isObjectNotEmpty(dataZone) && (
        <div className={classes.subZone}>
          <p className='ml-3 pt-1' style={{ fontSize: UNIT * 0.93 }}>
            {title}
          </p>
          {_.keys(dataZone).map((f, j) => (
            <div
              className={classes.details}
              style={{
                paddingBottom: _.keys(dataZone).length - 1 === j ? '10px' : '0px'
              }}
            >
              <ExpansionPanelDetails key={f} className={classes.panelDetail}>
                {this.renderDataZone(dataZone[f], j, false, e, typeZone)}
              </ExpansionPanelDetails>
            </div>
          ))}
        </div>
      )
    );
  };

  renderCity = renderCities => {
    const { classes } = this.props;
    const { expanded, selectedZone, isMap } = this.state;
    return (
      <div>
        {renderCities &&
          _.map(renderCities, (e, i) => {
            const { districts, subLocalities, name, data } = e;
            return (
              <ExpansionPanel
                expanded={expanded[name] === true && (subLocalities || districts)}
                onChange={(event, expanded) =>
                  isMap
                    ? this.setState({
                      selectedZone: e,
                      center: {
                        lng: data[0] ? data[0].longitude : data.longitude,
                        lat: data[0] ? data[0].latitude : data.latitude
                      }
                    }, () => {
                      e.shape === 'circle' ? onCircleClick(e, this) : onPolygonClick(e, this);

                    })
                    : handleChangeExpend(event, expanded, name, this)
                }

                square
                className={classes.expansioPanel}
                style={{
                  backgroundColor: selectedZone.key === e.key && isMap && mainColor.colorMediumGray
                }}
                key={e}
              >
                <ExpansionPanelSummary>{this.renderDataZone(e, i, true)}</ExpansionPanelSummary>
                {subLocalities && this.rendersubZone(subLocalities, e.name, SUBLOCALITY_LEVEL_1)}
                {this.rendersubZone(districts, e.name)}
              </ExpansionPanel>
            );
          })}
      </div>
    );
  };

  renderDeliveryZones = renderCities => {
    const { classes } = this.props;
    const { isMap, currentCities, rowsPerPage, page } = this.state;
    return (
      <>
        <Table>
          <TableContainer style={{ maxHeight: isMap && UNIT * 28.875 }}>
            <ExpansionPanel square className={`px-0 ${classes.panel}`} expanded={false}>
              <ExpansionPanelSummary>
                <div
                  className={isMap ? classes.zoneHeading : classes.heading}
                  style={{ flexBasis: isMap && (!isDeliveryPriceInKm() ? '20%' : '45%') }}
                >
                  Zone{' '}
                </div>
                <div className={isMap ? classes.zoneHeading : classes.heading}>Minimum </div>
                {!isDeliveryPriceInKm() && (
                  <div className={isMap ? classes.zoneHeading : classes.heading}>
                    Frais de livraison
                  </div>
                )}
                <div className={classes.lastCell} style={{ width: isMap ? 40 : 120 }} />
              </ExpansionPanelSummary>
            </ExpansionPanel>
            {this.renderCity(renderCities)}
          </TableContainer>
          <TableFooter>
            <TablePagination
              rowsPerPageOptions={[6, 12, 25]}
              count={_.keys(currentCities).length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage={!isMap ? 'Lignes par page' : ''}
              page={page}
              backIconButtonProps={{
                'aria-label': 'Previous Page'
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page'
              }}
              onChangePage={(event, page) => handleChangePage(event, page, 'page', this)}
              onChangeRowsPerPage={e => handleChangeRowsPerPage(e, 'rowsPerPage', this)}
            />
          </TableFooter>
        </Table>
      </>
    );
  };

  render() {
    const { classes, history, configurations } = this.props;
    const {
      addCityModal,
      updateCityModal,
      isMap,
      currentCities,
      page,
      rowsPerPage,
      selectedZone,
      deliveryZone,
      zoneLevel
    } = this.state;
    const { address = {} } = configurations;
    const { location = {} } = address;
    const renderCities = currentCities.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    return (
      <div className='col-12 p-4 px-0'>
        <div className='row mx-0 align-items-center'>
          <BackButton
            className='col-12 col-md-9 pl-0'
            onClick={() => history.goBack()}
            title={settings.deliveryZone.text}
            subtitle={settings.deliveryZone.description}
          />
          {this.state.isLoading ? null : (
            <div className='col-12 col-md-3 col-xl-3 d-flex justify-content-end align-items-end px-0'>
              <IconButton
                aria-label='map'
                className={`mx-2 ${isMap ? classes.mapIcon : classes.arroundIcon} my-0 mr-0`}
                style={{ backgroundColor: isMap && 'transparent' }}
                onClick={() => onChangeLayout(true, this)}
              >
                <MapIcon style={{ color: isMap && mainColor.secondaryColor }} />
              </IconButton>
              <IconButton
                aria-label='Menu'
                className={`mx-2 ${!isMap ? classes.mapIcon : classes.arroundIcon} my-0`}
                style={{ backgroundColor: !isMap && 'transparent' }}
                onClick={() => onChangeLayout(false, this)}
              >
                <MenuIcon style={{ color: !isMap && mainColor.secondaryColor }} />
              </IconButton>

              <IconButton
                aria-label='add'
                style={{
                  backgroundColor: mainColor.secondaryColor,
                  marginRight: 0
                }}
                className={`ml-2 my-0 `}
                onClick={() => handleCreateCity(FIRST_LEVEL, null, this)}
              >
                <AddIcon style={{ color: mainColor.colorWhite }} />
              </IconButton>
            </div>
          )}
        </div>

        <Paper style={{ overflowX: 'auto' }} className={` px-0 my-3 ${classes.root}`}>
          {isMap && (
            <div className='d-lg-flex mx-0'>
              <div
                className={`d-flex col-12 ${_.size(currentCities) > 0 && 'col-lg-8'} px-0`}
                style={{ overflowX: 'auto', height: 515 }}
              >
                <GoogleMap
                  mapContainerClassName='w-100 h-100'
                  onLoad={() =>
                    this.setState({
                      center: { lng: parseFloat(location.longitude), lat: parseFloat(location.latitude) }
                    })
                  }
                  center={this.state.center}
                  zoom={13}
                  options={{
                    mapTypeId: 'roadmap',
                    disableDoubleClickZoom: true,
                    mapTypeControlOptions: {
                      mapTypeIds: ['roadmap']
                    }
                  }}
                >
                  <Marker position={{ lng: parseFloat(location.longitude), lat: parseFloat(location.latitude) }} />
                  {isObjectNotEmpty(currentCities) &&
                    _.map(currentCities, e => {
                      const { shape, color, data, key, priority } = e;
                      const { longitude = '', latitude = '', radius = DEFAULT_RADIUS } = data;
                      return shape !== 'circle' ? (
                        <Polygon
                          key={key}
                          editable={selectedZone.key === key}
                          onClick={() => { this.setState({ selectedZone: e }); onPolygonClick(e, this) }}
                          draggable
                          path={_.map(data, obj => {
                            return { lng: obj.longitude, lat: obj.latitude };
                          })}
                          onMouseMove={() => onEditPolygon(e, this)}
                          onDragEnd={() => onEditPolygon(e, this)}
                          onLoad={polygon => onLoadPolygon(polygon, key, this)}
                          options={{
                            ...ZONE_OPTIONS,
                            zIndex: priority,
                            strokeColor: color,
                            fillColor: color
                          }}
                        />

                      ) : (
                        <Circle
                          key={key}
                          editable={selectedZone.key === key}
                          draggable
                          onDragEnd={() => onEditCircle(e, this)}
                          onLoad={(circle) => onLoadCircle(circle, key, this)}
                          onMouseMove={() => onEditCircle(e, this)}
                          onRadiusChanged={() => onEditCircle(e, this)}
                          onClick={() => { this.setState({ selectedZone: e }); onCircleClick(e, this) }}
                          radius={radius}
                          center={{ lng: longitude, lat: latitude }}
                          options={{
                            ...ZONE_OPTIONS,
                            zIndex: priority,
                            strokeColor: color,
                            fillColor: color,
                          }}
                        />

                      );
                    })}
                </GoogleMap>
              </div>
              {_.size(currentCities) > 0 && (
                <div className='col-12 col-lg-4 px-0'>{this.renderDeliveryZones(renderCities)}</div>
              )}
            </div>
          )}
          {!isMap && this.renderDeliveryZones(renderCities)}
        </Paper>
        {(addCityModal || updateCityModal) && (
          <DeliveryZoneModal
            zoneLevel={zoneLevel}
            closeModal={() => this.setState({ addCityModal: false, updateCityModal: false })}
            addCityModal={addCityModal}
            isOpen={addCityModal || updateCityModal}
            deliveryZone={_.cloneDeep(deliveryZone)}
            isMap={isMap}
            onClick={newZone => {
              const { data } = newZone;
              this.setState(
                isMap
                  ? {
                    selectedZone: newZone,
                    center: {
                      lng: data[0] ? data[0].longitude : data.longitude,
                      lat: data[0] ? data[0].latitude : data.latitude
                    }
                  }
                  : {
                    expanded: { [newZone]: true }
                  }
              );
            }}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, user }) {
  const { shop } = firebaseRealTime;
  const { shopId } = user;
  return {
    configurations: shop,
    shopId
  };
}
DeliveryZone.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(DeliveryZone)));
